"use client";

import React from "react";
import {
  EmailShareButton,
  FacebookShareButton,
  GabShareButton,
  HatenaShareButton,
  InstapaperShareButton,
  LineShareButton,
  LinkedinShareButton,
  LivejournalShareButton,
  MailruShareButton,
  OKShareButton,
  PinterestShareButton,
  PocketShareButton,
  RedditShareButton,
  TelegramShareButton,
  TumblrShareButton,
  TwitterShareButton,
  ViberShareButton,
  VKShareButton,
  WhatsappShareButton,
  WorkplaceShareButton,
} from "react-share";

import {
  AiOutlineMail,
  AiFillFacebook,
  AiOutlineMessage,
  AiFillBook,
  AiFillLinkedin,
  AiFillTwitterCircle,
  AiOutlineReddit,
  AiOutlineSend,
  AiOutlineWhatsApp,
  AiFillInstagram,
  AiOutlinePushpin,
  AiOutlineGlobal,
  AiOutlineUser,
  AiOutlineShareAlt,
} from "react-icons/ai";

import { CiShare2 } from "react-icons/ci";

import { Button, buttonVariants } from "../ui/button";
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../ui/alert-dialog";
import { Heading } from "./Heading";
import CopyButton from "./CopyButton";

const ShareSection = ({ url, title }: { url: string; title: string }) => {
  const shareButtons = [
    { Component: EmailShareButton, Icon: AiOutlineMail, label: "Email" },
    { Component: FacebookShareButton, Icon: AiFillFacebook, label: "Facebook" },
    { Component: GabShareButton, Icon: AiOutlineMessage, label: "Gab" },
    { Component: HatenaShareButton, Icon: AiFillBook, label: "Hatena" },
    { Component: InstapaperShareButton, Icon: AiFillBook, label: "Instapaper" },
    { Component: LineShareButton, Icon: AiOutlineMessage, label: "Line" },
    { Component: LinkedinShareButton, Icon: AiFillLinkedin, label: "LinkedIn" },
    {
      Component: LivejournalShareButton,
      Icon: AiFillBook,
      label: "LiveJournal",
    },
    { Component: MailruShareButton, Icon: AiOutlineMail, label: "Mail.ru" },
    { Component: OKShareButton, Icon: AiOutlineUser, label: "OK" },
    {
      Component: PinterestShareButton,
      Icon: AiOutlinePushpin,
      label: "Pinterest",
    },
    { Component: PocketShareButton, Icon: AiFillBook, label: "Pocket" },
    { Component: RedditShareButton, Icon: AiOutlineReddit, label: "Reddit" },
    { Component: TelegramShareButton, Icon: AiOutlineSend, label: "Telegram" },
    { Component: TumblrShareButton, Icon: AiOutlineGlobal, label: "Tumblr" },
    {
      Component: TwitterShareButton,
      Icon: AiFillTwitterCircle,
      label: "Twitter",
    },
    { Component: ViberShareButton, Icon: AiOutlineMessage, label: "Viber" },
    { Component: VKShareButton, Icon: AiOutlineUser, label: "VK" },
    {
      Component: WhatsappShareButton,
      Icon: AiOutlineWhatsApp,
      label: "WhatsApp",
    },
    {
      Component: WorkplaceShareButton,
      Icon: AiOutlineShareAlt,
      label: "Workplace",
    },
  ];

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          variant={"outline"}
          className="w-fit"
          aria-label="Share product link"
        >
          <CiShare2 />
        </Button>
      </AlertDialogTrigger>

      <AlertDialogContent>
        <AlertDialogHeader className="flex flex-col items-center justify-center gap-5">
          <AlertDialogTitle>
            <Heading>Social Share</Heading>
          </AlertDialogTitle>
          {/* <AlertDialogDescription> */}
          <div className="flex flex-wrap items-center justify-center gap-4">
            <CopyButton textToCopy={url} />

            {shareButtons.map(({ Component, Icon, label }, index) => (
              <div key={index} className="flex flex-col items-center">
                <Component url={url} title={title} media={""}>
                  <div className={buttonVariants({ variant: "outline" })}>
                    <Icon />
                  </div>
                </Component>
                <span className="mt-2 text-sm">{label}</span>
              </div>
            ))}
          </div>
          {/* </AlertDialogDescription> */}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ShareSection;
